export default __webpack_public_path__ + "static/media/fw-grace-er-Rose Gold.70cc1c4d.mp4";